/**
 * Les marqueurs `[image:N]` d'un message.
 *
 * Le serveur remplace chaque `[image:N]` par la N-ième image envoyée : retirer
 * une image doit donc renuméroter les marqueurs du texte, sinon la mauvaise
 * image finirait au mauvais endroit.
 */
const MARQUEUR = /\[image:(\d+)\]/g;

/**
 * Le texte après le retrait de l'image de rang `rang` (à partir de 1) : son
 * marqueur disparaît, ceux des images suivantes reculent d'un rang.
 *
 * Sans cela, retirer la première de trois images laissait `[image:3]` dans le
 * texte alors qu'il n'en restait que deux : la dernière ne s'affichait plus, et
 * la deuxième prenait la place de la première.
 */
export function retirerMarqueurImage(texte, rang) {
  if (!texte) return texte ?? '';

  return texte.replace(MARQUEUR, (marqueur, chiffres) => {
    const n = Number(chiffres);

    if (n === rang) return '';
    return n > rang ? `[image:${n - 1}]` : marqueur;
  });
}
